import {
    getPlaylistsUrl,
    getPlaylistUrl,
    getSearchAlbumsUrl,
    getSearchArtistsUrl,
    getSearchAllUrl,
    getAlbumUrl,
    getDiscoUrl,
    getSimilarUrl,
    decrypt,
    getLoginUrl,
} from './Api'

const isCryptedDataRegexp = /^[A-Z0-9]*$/
function isCryptedData(data: string) {
    return data && data.length > 10 && isCryptedDataRegexp.test(data)
}

async function fetchUrl(
    url: string,
    options?: {
        signal?: AbortSignal,
        method?: 'GET' | 'POST' | 'PUT' | 'DELETE',
        body?: string,
    }) {
    try {
        const res = await fetch(url, {
            signal: options ? options.signal : undefined,
            method: options ? options.method : 'GET',
            body: options ? options.body : undefined,
            headers: { 'Content-type': 'application/json' },
        })

        // try {
        //     const json = await res.json()
        //     console.log('json', json)
        //     return json
        // } catch (err) {
        //     const text = await res.text()
        //     if (!text)
        //         return null
        //     const json = JSON.parse(decrypt(text))
        //     console.log('json', json)
        //     return json
        // }

        const text = await res.text()
        if (!text)
            return null
        if (isCryptedData(text))
        {
            const json = JSON.parse(decrypt(text))
            return json
        }
        else
        {
            const json = JSON.parse(text)
            return json
        }
    } catch (error) {
        // console.log('error', error)
        throw error;
    }
}

// async function putUrl(url: string, body: string) {
//     try {
//         const res = await fetch(url, {
//             // signal: signal,
//             method: 'PUT',
//             body: body,
//         })
//     } catch (error) {
//         throw error
//     }
// }

export async function getLogin(email: string, pwd: string) {
    return await fetchUrl(getLoginUrl(email, pwd))
}

export interface Playlist {
    id: string
    type: string
    name: string
    uri: string
    track_count: number
    owner_id: string
    img_url: string
    tile_url: string
    tile_alt_url: string
    preview_artists: {
        id: number,
        name: string,
        img_url: string,
        uri: string,
    }[]
}
export interface PlaylistsResponse {
    results: Playlist[]
}

export async function getPlaylists(userId: string): Promise<PlaylistsResponse> {
    return await fetchUrl(getPlaylistsUrl(userId))
}

export interface PlaylistResponse {
    item: {
        id: string
        name: string
        tile_url: string
    }
    results: {
        tracks: Track[]
    }
}
export interface Track {
    barcode: string
    cover_url: string
    album: string
    title: string
    artists: {
        id: number,
        name: string,
        img_url: string,
        uri: string,
    }[]
    duration: number
    streamable: number
    opencatalog: number
    features: number
    album_uri: string
    street_date: string
    scoring: number
    uid: string
}
export async function getPlaylist(userId: string, playlistId: string): Promise<PlaylistResponse> {
    var playlist = await fetchUrl(getPlaylistUrl(userId, playlistId))
    
    if(playlist.results)
    {
        var tmp = playlist.results.tracks.map((tr: any)=>{return {...tr,uid : Math.random().toString(36).substr(2, 9)}})
        playlist.results.tracks=tmp;
    }
    return playlist
}
export async function setPlaylist(userId: string, playlistId: string, name: string, tracks: Track[]): Promise<void> {
    return await fetchUrl(getPlaylistUrl(userId, playlistId), {
        method: 'PUT',
        body: JSON.stringify({
            name,
            tracks: tracks.map(tr => ({ barcode: tr.barcode }))
        }),
    })
}

export async function renamePlaylist(
    userId: string,
    playlistId: string,
    name: string) {
    return await fetchUrl(getPlaylistUrl(userId, playlistId), {
        method: 'POST',
        body: JSON.stringify({ name }),
    })
}

export async function createPlaylist(userId: string, name: string): Promise<PlaylistResponse> {
    return await fetchUrl(getPlaylistUrl(userId), {
        method: 'POST',
        body: JSON.stringify({ name }),
    })
}

export async function deletePlaylist(userId: string, playlistId: string) {
    return await fetchUrl(getPlaylistsUrl(userId, playlistId), {
        method: 'DELETE',
    })
}

interface SearchAllResponse {

}
export async function getSearchAll(query: string) {
    return await fetchUrl(getSearchAllUrl(query))
}

interface SearchAlbumsResponse {

}
export async function getSearchAlbums(query: string) {
    return await fetchUrl(getSearchAlbumsUrl(query))
}

export interface Artist {
    id: number
    name: string
    img_url: string
    match: string
    uri: string
    albums?: Album[]
}
export interface SearchArtistsResponse {
    results: {
        artists: Artist[]
    } | undefined
}
export async function getSearchArtists(query: string, signal?: AbortSignal): Promise<SearchArtistsResponse> {
    return await fetchUrl(getSearchArtistsUrl(query), { signal })
}

export interface Album {
    barcode: string
    name: string
    artists: {
        id: number
        name: string
        img_url: string
        uri: string
    }[];
    ntracks: number
    duration: number
    streetdate: string
    cover_url: string
    streamable: number
    opencatalog: number
    features: number
    uri: string
}
export interface DiscographyResponse {
    meta: {
        albums?: {
            total: number
        }[]
    }
    item: {
        id: number
        name: string
        img_url: string
        style: string
        theme: number
        uri: string 
    }
    results: {
        albums: Album[]
    } | undefined
}
export async function getDisco(artistId: number, options?: {
    signal?: AbortSignal | undefined,
    count?: number,
}): Promise<DiscographyResponse> {
    return await fetchUrl(getDiscoUrl(artistId, options && options.count), {
        signal: options && options.signal
    })
}

export interface Track {
    barcode: string
    cover_url: string
    artists: {
        id: number
        name: string
        img_url: string
        uri: string
    }[]
    album: string
    title: string
    duration: number
    streamable: number
    opencatalog: number
    features: number
    album_uri: string
    street_date: string
    plays: number
    scoring: number
}

interface AlbumResponse {
    item: {
        barcode: string
        name: string
        artists: {
            id: number
            name: string
            img_url: string
            uri: string
        }[]
        ntracks: number
        duration: number
        streetdate: string
        cover_url: string
        streamable: number
        opencatalog: number
        features: number
        uri: string
    }
    results: {
        tracks: Track[]
    } | undefined
}

export async function getAlbum(barcode: string, signal?: AbortSignal): Promise<AlbumResponse> {
    return await fetchUrl(getAlbumUrl(barcode), {
        signal
    })
}

export interface SimilarArtist {
    id: number,
    name: string,
    img_url: string,
    uri: string,
}
export interface SimilarArtistResponse {
    meta: {
        session_name: string,
        session_id: string,
        kind: string,
        title: string,
        relatedartists: [
            {
                bench: number
            }
        ]
    },
    item: {
        name: string,
        img_url: string,
        id: number,
        style: string,
        theme: number,
        uri: string,
        mmix: number,
    },
    results: {
        "related-artists": SimilarArtist[]
    }
}
export async function getSimilarArtists(artistId: number): Promise<SimilarArtistResponse> {
    return await fetchUrl(getSimilarUrl(artistId))
}